import { Environment } from "../types/types";

export const getEnvironment = (): Environment => {
  if (
    window.location.hostname.endsWith(".dev") ||
    window.location.hostname.includes("localhost") ||
    window.location.hostname.endsWith(".internal")
  ) {
    return "dev-au";
  }

  return "prod-au";
};
